import {
    IGridAppearance,
    IGridCell,
    IGridCellAreaStyles,
    IGridCellRenderer
} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {GridRendererRegistry} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridRendererRegistry';
import {observable} from 'mobx';

export class GridAppearance implements IGridAppearance
{
    @observable
    public isColumnHeaderVisible;

    @observable
    public isRowHeaderVisible;

    @observable
    public hasBorder;

    @observable
    public hasVerticalLines;

    @observable
    public hasHorizontalLines;

    private readonly _cellAreaStyles:IGridCellAreaStyles;

    constructor(private cellAreaStylesCtor:(new (GridAppearance) => IGridCellAreaStyles),
                private _rendererRegistry:GridRendererRegistry)
    {
        this._cellAreaStyles = new cellAreaStylesCtor(this);
    }

    getCellAreaStyles():IGridCellAreaStyles
    {
        return this._cellAreaStyles;
    }

    getRendererRegistry():GridRendererRegistry
    {
        return this._rendererRegistry;
    }

    getRendererFor(cell:IGridCell):IGridCellRenderer | null
    {
        if( !cell )
        {
            console.error(`Error: null/undefined cell: ${cell}`);
            return null;
        }

        const kind = cell.getKind();
        return this._rendererRegistry.getRendererFor(kind);
    }
}
